import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	Ddp: null as string | null,
	DoplnekMk: null as string | null,
	DphSzbOzn: null as boolean | null,
	ModelRok: null as string | null,
	NcGd: null as number | null,
	Pc: null as number | null,
	PlatnostDat: null as Date | null,
	Text: null as string | null,
	Typkod: null as string | null,
	VerzeMk: null as string | null,
	VstupDat: null as Date | null,
	VybavaVazba: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
		DphSazbaOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
